import { getProductsStationCountrySuggestions } from '@/api/generated/products-stations/products-stations';
import type { ListRequest, StationCountrySuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';
import { createAsyncSelectorField } from '@/shared/forms';
import type { CountryRef } from '../productsApi';

const countrySelector = defineEntityAsyncSelector<
  CountryRef,
  StationCountrySuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getProductsStationCountrySuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('products.stations.countries', request),
    mapItem: (s) => ({
      countryId: s.countryId,
      name: s.name ?? '',
      isoCode: s.isoCode ?? null,
    }),
  },
  key: (item) => item.countryId,
  objectCategory: 'Country',
  listPicker: 'legacy',
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.isoCode,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('stationSelectors.country.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'isoCode',
        header: t('stationSelectors.country.columns.iso'),
        value: (item) => item.isoCode,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'products' },
});

export const CountrySelector = countrySelector.Selector;
export const CountrySelectorField = createAsyncSelectorField(CountrySelector);
